export const apis = {
  production: "https://api-perfilpolitico.serenata.ai/",
  staging: "https://staging-api-perfilpolitico.serenata.ai/",
};
